import { SiteCabinetVeterinaire } from "../SiteCabinetVeterinaire";

export class DataModelAddCabinet {
    id: number = 0
    nom: string = "";
    siteCabinets: SiteCabinetVeterinaire[]  = [];
}